import React, { useMemo, useState } from "react";
import "./proyectos.css";
import projectsData from "../infoProyectos/dataProyectos";

const TEXTS = {
  es: {
    title: "Proyectos",
    subtitle:
      "Selección de proyectos reales y experimentos, con foco en UX, performance y producto.",
    searchPlaceholder: "Buscar por nombre, stack, etc.",
    onlyFeatured: "Solo destacados",
    featured: "Destacados",
    all: "Todos",
    live: "Live",
  },
  en: {
    title: "Projects",
    subtitle:
      "Selection of real-world projects and experiments, focused on UX, performance, and product.",
    searchPlaceholder: "Search by name, stack, etc.",
    onlyFeatured: "Featured only",
    featured: "Featured",
    all: "All",
    live: "Live",
  },
};

function ProjectCard({ p, t }) {
  return (
    <article className={`p-card ${p.featured ? "featured" : ""}`}>
      <div className="p-media">
        <img src={p.imagen} alt={p.Name} loading="lazy" />
      </div>

      <div className="p-body">
        <div className="p-top">
          <h3 className="p-title">{p.Name}</h3>
          <span className="p-date">{p.fechaRealizado}</span>
        </div>

        {p.tagline && <p className="p-desc">{p.tagline}</p>}

        {!!p.stack?.length && (
          <div className="p-tags">
            {p.stack.slice(0, 6).map((t) => (
              <span key={t} className="badge">
                {t}
              </span>
            ))}
          </div>
        )}

        <div className="p-actions">
          {p.LinkWeb ? (
            <a className="btn btn-primary" href={p.LinkWeb} target="_blank" rel="noreferrer">
              {t.live}
            </a>
          ) : (
            <span className="btn btn-disabled" aria-disabled="true">
              {t.live}
            </span>
          )}

          <a className="btn" href={p.LinkGit} target="_blank" rel="noreferrer">
            GitHub
          </a>
        </div>
      </div>
    </article>
  );
}

export default function Proyectos() {
  const [lang, setLang] = useState("es");
  const [query, setQuery] = useState("");
  const [onlyFeatured, setOnlyFeatured] = useState(false);

  const t = TEXTS[lang];

  const { featured, rest } = useMemo(() => {
    const q = query.trim().toLowerCase();

    const filtered = projectsData.filter((p) => {
      if (onlyFeatured && !p.featured) return false;
      if (!q) return true;
      const hay =
        (p.Name || "").toLowerCase().includes(q) ||
        (p.tagline || "").toLowerCase().includes(q) ||
        (p.stack || []).join(" ").toLowerCase().includes(q);
      return hay;
    });

    return {
      featured: filtered.filter((p) => p.featured),
      rest: filtered.filter((p) => !p.featured),
    };
  }, [query, onlyFeatured]);

  return (
    <div className="p-wrap">
      <div className="p-header card">

        {/* Language toggle */}
        <div className="p-lang">
          <button
            className={`lang-btn ${lang === "es" ? "active" : ""}`}
            onClick={() => setLang("es")}
          >
            ES
          </button>
          <button
            className={`lang-btn ${lang === "en" ? "active" : ""}`}
            onClick={() => setLang("en")}
          >
            EN
          </button>
        </div>

        <div>
          <h1 className="p-h1">{t.title}</h1>
          <p className="p-sub">{t.subtitle}</p>
        </div>

        <div className="p-controls">
          <input
            className="p-search"
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder={t.searchPlaceholder}
          />

          <label className="p-toggle">
            <input
              type="checkbox"
              checked={onlyFeatured}
              onChange={(e) => setOnlyFeatured(e.target.checked)}
            />
            <span>{t.onlyFeatured}</span>
          </label>
        </div>
      </div>

      {!!featured.length && !onlyFeatured && (
        <section className="p-section">
          <div className="p-section-title">
            <h2>{t.featured}</h2>
            <span className="p-line" />
          </div>
          <div className="p-grid p-grid-featured">
            {featured.map((p) => (
              <ProjectCard key={p.Name} p={p} t={t} />
            ))}
          </div>
        </section>
      )}

      <section className="p-section">
        <div className="p-section-title">
          <h2>{onlyFeatured ? t.featured : t.all}</h2>
          <span className="p-line" />
        </div>

        <div className="p-grid">
          {(onlyFeatured ? featured : [...featured, ...rest]).map((p) => (
            <ProjectCard key={p.Name} p={p} t={t} />
          ))}
        </div>
      </section>
    </div>
  );
}
